import React from 'react';
import useUser from '../hooks/useUser';
import ServerSubmasters from '../masters/server/Submasters';
import ClientSubmasters from '../masters/client/Submasters';

const Submasters = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    if (roleLower === 'client') {
        return <ClientSubmasters />;
    }
    return <ServerSubmasters />;
};
export default Submasters;
